import { EventBus } from "../../../eventbus";
import { baseUrl } from "../../../config";
import i18n from "../../../functions/i18next";

export default {
  props: {
    item: Object,
  },
  data() {
    return {
      company: this.$store.state.company,
      key: this.$store.state.user.key,
      state: "add",
      type: "",
      id: "",
      name: "",
      color: "",
      extension: "",
      thumbnail: "",
      users: "",
      filteredUsers: "",
      searchUser: "",
      searchResults: false,
      recipients: [],
      recipientKey: "",
      note: "",
      error: false,
      message: "",
    };
  },
  created() {
    this.setVariables();

    /*EventBus.$on("show-notify-file", (data) => {
      if (this.id != data[0]) {
        // Refresh when the state is opened
        this.refresh();
      }

      this.id = data[0];
      this.name = data[1];
      this.extension = data[2];
      this.thumbnail = data[3];

      this.type = "file";
      this.show = true;
      this.getUsers();
    });

    EventBus.$on("show-notify-folder", (data) => {
      if (this.id != data[0]) {
        // Refresh when the state is opened
        this.refresh();
      }

      this.id = data[0];
      this.name = data[1];
      this.color = data[2];

      this.type = "folder";
      this.show = true;
      this.getUsers();
    });*/

    setTimeout(() => {
      if (this.$refs.emails) {
        this.$refs.emails.focus();
      }
    }, 300);
  },
  methods: {
    setVariables() {
      if (this.id !== this.item.id) {
        // Refresh when the state is opened
        this.refresh();
      }

      this.id = this.item.id;
      this.name = this.item.name;

      if (this.item.extension) {
        //is file
        this.extension = this.item.extension;
        this.thumbnail = this.item.thumbnail;

        this.type = "file";
      } else {
        //is folder
        this.color = this.item.color;

        this.type = "folder";
      }

      this.getUsers();
    },

    refresh() {
      this.state = "add";

      this.type = "";
      this.id = "";
      this.name = "";
      this.color = "";
      this.extension = "";
      this.thumbnail = "";

      this.users = "";
      this.recipients = [];
      this.note = "";
    },
    /**
     * If the file has a thumbnail set the thumbnail
     * Else set the file type icon
     *
     * @returns {string|string|*}
     */
    setThumbnail() {
      switch (this.thumbnail) {
        case null:
          return `../../../symbols/fileicons/small/${this.extension.replace(
            ".",
            ""
          )}.svg`;
        default:
          return this.thumbnail;
      }
    },
    /**
     * Get all the users
     */
    getUsers() {
      this.$axios.get(baseUrl + "/companyusers").then((response) => {
        this.users = response.data;
        for (let user in this.users) {
          this.users[user].recipient = false;
        }
        this.filteredUsers = this.users;
      });
    },
    /**
     * Get the filtered users
     */
    getFilteredUsers() {
      this.error = false;

      if (this.searchUser == "") {
        this.filteredUsers = this.users;
        this.searchResults = false;
      } else {
        var results = [];
        for (var i = 0; i < this.users.length; i++) {
          /* Check if the names match */
          if (
            this.users[i].name
              .toLowerCase()
              .includes(this.searchUser.toLowerCase())
          ) {
            results.push(this.users[i]);
          }
          /* Check if the usernames match */
          if (
            this.users[i].username
              .toLowerCase()
              .includes(this.searchUser.toLowerCase())
          ) {
            /* Check if the user is already added to the results */
            if (!results.includes(this.users[i])) {
              results.push(this.users[i]);
            }
          }
          /* Check if the email match */
          if (
            this.users[i].email
              .toLowerCase()
              .includes(this.searchUser.toLowerCase())
          ) {
            /* Check if the user is already added to the results */
            if (!results.includes(this.users[i])) {
              results.push(this.users[i]);
            }
          }
        }
        this.filteredUsers = results;
        this.searchResults = true;
      }
    },
    /**
     * Add a recipient to the list
     *
     * @param value
     */
    addRecipient(value) {
      var re =
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      if (
        this.recipients.length >= 1 &&
        this.recipients.filter((recipient) => recipient.email === value)
          .length > 0
      ) {
        return;
      } else if (!re.test(value)) {
        this.searchResults = "";
        this.error = true;
        this.message = i18n.tc("common.email_error", 1);
        return;
      } else {
        let item = {};
        let found = false;

        // check if the email already exists
        for (let user in this.users) {
          let email = this.users[user].email;
          if (email == value) {
            found = true;
            this.users[user].recipient = true;
            break;
          }
        }

        // set the type
        if (found) {
          item.type = "user";
        } else {
          item.type = "email";
        }

        // set the value
        item.email = value;

        // add the recipient
        this.recipients.push(item);
        this.searchUser = "";
        this.searchResults = false;
      }
    },
    /**
     * Remove a recipient
     *
     * @param value
     */
    removeRecipient(value) {
      // check if the email already exists
      for (let user in this.users) {
        let email = this.users[user].email;
        if (email == value) {
          this.users[user].recipient = false;
        }
      }

      // remove from recipients
      for (let recipient in this.recipients) {
        let email = this.recipients[recipient].email;
        if (email == value) {
          this.recipients.splice(recipient, 1);
        }
      }
    },
    send(type) {
      let emails = [];

      // get the recipients mail addresses
      for (let recipient in this.recipients) {
        let email = this.recipients[recipient].email;
        emails.push(email);
      }

      let formData = new FormData();
      formData.append("company", this.company);
      formData.append("key", this.key);
      formData.append("id", this.id);
      formData.append("emails", JSON.stringify(emails));
      formData.append("note", this.note);

      if (type == "file") {
        this.$axios
          .post(baseUrl + "/notify/file", formData)
          .then((response) => {
            if (response.data.message == "OK") {
              //close again
              EventBus.$emit(`closeallactions`);
            }
          });
      } else {
        this.$axios
          .post(baseUrl + "/notify/folder", formData)
          .then((response) => {
            if (response.data.message == "OK") {
              //close again
              EventBus.$emit(`closeallactions`);
            }
          });
      }
    },
  },
};
